import React from 'react'
import { SlideImgProps } from './types'

export default function SlideImg({ img, styleClass }: SlideImgProps) {
    return (
        <li className={styleClass}>
            <img src={img} alt='' />
        </li>
    )
}
